import { resumeWorkflow } from '@/utils/maaran'
import { useMutation } from '@tanstack/react-query'

export default function useResumeWorkflow() {
    const {mutateAsync, isPending} = useMutation({
        mutationFn: resumeWorkflow,
    });

    return {mutateAsync, isPending}
}
